import { create } from 'zustand';

interface SidebarState {
  isOpenSidebar: boolean;
  setIsOpenSidebar: (isOpenSidebar: boolean) => void;
}

const useSidebarStore = create<SidebarState>((set) => ({
  isOpenSidebar: false,
  setIsOpenSidebar: (isOpenSidebar) => set({ isOpenSidebar }),
}));
export default useSidebarStore;
